export default "__VITE_ASSET__B98k6rkB__"